<template>
    <div class="container__grid">
        <div class="box__left">
            <header>
                <h1>{{t.how_to_start}}</h1>
            </header>
            <article class="body">
                <!-- <a v-if="quickStartUrl" target="_blank" :href="quickStartUrl" class="quick-start">
                    {{t.quick_start}}&nbsp;&nbsp;&nbsp;
                    <img
                        src="/internacional/public/office3/img/dashboard/training/ic-open-white.png"
                    >
                </a>-->
                <a
                    v-if="quickStartUrl"
                    target="_blank"
                    :href="quickStartUrl"
                    class="quick-start"
                    v-text="t.quick_start"
                ></a>
                <div v-if="loading" class="loading"></div>
                <div class="scrool__inverse">
                    <div v-for="(level, index) in allInfo" :key="index">
                        <label>{{level.title}}</label>
                        <div
                            v-for="(category, index) in level.categories"
                            :class="[{ selected: activeCategory == category.id }, 'normal__sentence categories']"
                            :key="index"
                            :data-id="index"
                            @click="handleClickCategory(category)"
                        >{{category.title }}</div>
                    </div>
                </div>
                <!-- <div class="hr"></div>
                <h2 v-html="t.tutorials"></h2>
                <div class="tutorials">
                    <div
                        class="normal__sentence categories"
                        v-for="(category, index) in this.allItemsTutorials"
                        :key="index"
                        :data-id="`last`"
                        @click="handleClickCategory"
                    >{{category}}</div>
                </div> -->
                <a
                    :href="view.routes.rota_office_support"
                    class="btn not-finded"
                    v-text="t.didnt_find_what_i_need"
                ></a>
            </article>
        </div>
        <div class="box__middle">
            <header>
                <h1>{{t.create_online_presence}}</h1>
                <h4>{{t.your_main_tools_for_your_bussiness}}</h4>
            </header>
            <article class="body">
                <transition-group name="slide-fade">
                    <div v-for="(item, index) in this.allSubItens" :key="index+1" :data-id="index">
                        <a
                            v-if="item.link"
                            @click="handleVideo(item)"
                            :class="[{ selected: item.id == selectedVideo.id }, 'normal__sentence']"
                        >{{item.title}}</a>
                        <a v-else class="normal__sentence no-link">{{item.title}}</a>
                        <div
                            class="childrens"
                            v-for="(subItem, indexSub) in item.sub_training"
                            :key="indexSub"
                        >
                            <a
                                @click="handleVideo(subItem)"
                                :class="[{ selected: subItem.id == selectedVideo.id }, 'normal__sentence']"
                            >{{subItem.title}}</a>
                        </div>
                    </div>
                </transition-group>
            </article>
        </div>
        <div class="box__right">

            <div>

                <div v-if="selectedVideo.iframe.embed == ''" style="display: flex;justify-content: center;">
                    <img
                        v-if="this.view.father_is_builderall"
                        src="/internacional/public/office3/img/dashboard/training/ic-logo-right.svg"
                    >
                    <img v-else :src="this.view.franquia_config_options.logo_path">
                </div>

                <div v-else class="container__youtube">
                    <iframe
                        ref="trainingVideo" 
                        :src="selectedVideo.iframe.embed" 
                        frameborder="0" 
                        width="100%" 
                        height="400" 
                        webkitallowfullscreen 
                        mozallowfullscreen 
                        allowfullscreen 
                        allow="autoplay; fullscreen">
                    </iframe>                                        
                </div>

            </div>

            <a :href="view.routes.rota_office_index" class="button3" v-text="t.go_to_your_office"></a>
            
        </div>
    </div>
</template>

<script>
export default {
    name: "dashboard-training",
    props: ["view"],
    data() {
        return {
            allInfo: [],
            allCategories: [],
            allSubItens: [],
            allSubSubItens: [],
            allItemsTutorials: [],
            t: [],
            loading: false,
            quickStartUrl: null,
            activeCategory: null,
            selectedVideo: {
                'iframe': {
                    'embed' : ''
                }
            }
        };
    },
    methods: {
        getAllTutorials() {
            this.loading = true;

            const BASE_URI = `${window.location.origin}${
                window.location.pathname
            }`;

            axios
                .post(`${BASE_URI}/get-all-training`)
                .then(response => {
                    if (response.data.success == true) {
                        //all info in one object
                        this.allInfo = response.data.categories;
                        
                        //forech title put in one array
                        // response.data.categories.forEach(item => {
                        //     //do not show support in normal tutorial
                        //     if (item.id == 12 && this.view.father_is_builderall) {
                        //         this.allItemsTutorials.push(item);
                        //     } else {
                        //         this.allCategories.push(item);
                        //     }
                        // });
                        this.loading = false;
                        this.preSelect();
                    }
                })
                .catch(error => {
                    // console.log("erro", error, error.response);
                });
        },
        handleClickCategory(categoryParam, video = false) {
            /*
            let allCategories = document.querySelectorAll(
                ".normal__sentence.categories"
            );
            //remove class selected
            allCategories.forEach(item => {
                item.classList.remove("selected");
            });
            //add class on selected
            event.target.classList.add("selected");
            */
            
            this.activeCategory = categoryParam.id

            //altera a URL para poder ser compartilhada
            let currentURL = (location.protocol + '//' + location.host + location.pathname);

            if (video !== false) {
                this.selectedVideo = video;
                window.history.replaceState('', '', currentURL+"?category="+this.activeCategory+'&video='+video.id);
            } else {
                window.history.replaceState('', '', currentURL+"?category="+this.activeCategory);
            }

            /*
            let idClick = event.target.dataset.id;
            let target = 0;
            if(idClick == 'last') {
                target = this.allInfo[this.allInfo.length - 1];
            } else {
                target = this.allInfo[idClick];
            }
            */

            //send all the training
            this.handleSubItem(categoryParam.training);
              $([document.documentElement, document.body]).animate({
                scrollTop: $(".box__middle").offset().top
            }, 500);
        },
        handleSubItem(allSubItemReceive) {
            //clean the user array
            this.allSubItens = [];
            this.allSubSubItens = [];
    
            // add the new text in to the array
            allSubItemReceive.forEach(item => {
                this.allSubItens.push(item);
            });
        },

        handleVideo(video) {
            if (video.iframe.error) {
                toastr.error(video.iframe.error+"\nPlease, contact support.")
                return;
            }
            this.selectedVideo = video

            // replace url
            let currentURL = (location.protocol + '//' + location.host + location.pathname);
            window.history.replaceState('', '', currentURL+"?category="+this.activeCategory+'&video='+video.id);

            // animate mobile
            if (document.body.offsetWidth < 900) {
                $([document.documentElement, document.body]).animate({
                    scrollTop: $(".box__right").offset().top
                }, 500);
            }
        },

        getUrlParam(name) {
            if(location.href.indexOf(name+"=") > -1) {
                let param = location.search.split(name+'=')[1];
                if (parseInt(param)) { 
                    return parseInt(param);
                }
            }
        },

        preSelect(){
            //category param
            let idCategory = this.getUrlParam('category');
            let idVideo = this.getUrlParam('video');
            let videoFound = false;

            if (idCategory) {
                Object.keys(this.allInfo).forEach(key => {
                    Object.keys(this.allInfo[key].categories).forEach(key2 => { 
                        if (this.allInfo[key].categories[key2].id == parseInt(idCategory)){

                            // video param
                            if (idVideo) {
                                let searchRecursive = this.allInfo[key].categories[key2].training;
                                Object.keys(searchRecursive).forEach(key3 => {
                                    if (searchRecursive[key3].id == idVideo) {
                                        this.handleClickCategory(this.allInfo[key].categories[key2], searchRecursive[key3]);
                                        videoFound = true;
                                        return;
                                    }
                                    Object.keys(searchRecursive[key3].sub_training).forEach(key4 => {
                                        if (searchRecursive[key3].sub_training[key4].id == idVideo) {
                                            this.handleClickCategory(this.allInfo[key].categories[key2], searchRecursive[key3].sub_training[key4]);
                                            videoFound = true;
                                            return;
                                        }
                                    })
                                })
                                if (!videoFound) {
                                    this.handleClickCategory(this.allInfo[key].categories[key2]);
                                }
                            } else {
                                this.handleClickCategory(this.allInfo[key].categories[key2]);
                            }
                        }
                    })
                })
            }
        }
    },
    
    mounted() {
        this.getAllTutorials();
    // console.log(this.view.father_is_builderall);
    
        //easy way to write
        this.t = this.view.translations;
        console.log(this.view.lang);
        if(this.view.lang == 'us' || this.view.lang == 'br' || this.view.lang == 'es') {
            this.quickStartUrl = false;
        } else {
            this.quickStartUrl = this.view.quick_start_url;
        }
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../../../scss/office";
.container__grid {
    display: grid;
    grid-template-columns: 25% 30% 1fr;
    min-height: 100vh;
    background: white;
    .box__left {
        background: var(--theme-color-primary);
        display: flex;
        flex-direction: column;
        box-shadow: 4px 0px 16px -9px var(--theme-color-primary);
        .loading {
            height: 50px;
            width: 50px;
            border-radius: 100%;
            margin: 0 auto;
            border: 4px solid var(--theme-color-primary-light);
            border-top-color: white;
            border-bottom-color: white;
            animation: loading 1s linear infinite;
        }
        header {
            background: var(--theme-color-primary-light);
            box-shadow: 0px 4px 16px -9px var(--theme-color-primary);
            flex: 10%;
            h1 {
                margin: 0;
                padding: 2.5rem 0;
                text-align: center;
                color: white;
                font-weight: bold;
                font-size: 1.5rem;
            }
        }
        article.body {
            display: flex;
            flex-direction: column;
            padding: 1rem 1rem 3rem 1rem;
            flex: 90%;

            .scrool__inverse {
                height: calc(100vh - 349px); overflow-y: auto;
                overflow-y: auto;
                &::-webkit-scrollbar-thumb {
                    background: #e9edf2;
                }
                &::-webkit-scrollbar-track {
                    background: var(--theme-color-primary);
                }
                label:not(:empty) {
                    color: #fff;
                    border-bottom: 1px solid;
                    padding: 9px 0;
                    width: auto;
                    font-size: .9rem;
                    margin: .7rem 10px .7rem 20px;
                    display: block;
                }
            }

            .normal__sentence {
                color: white;
                padding: 0.8rem 40px 0.8rem 1rem;
                margin: 0.7rem 10px 0.7rem 35px;
                border: 1px solid transparent;
                border-radius: 8px;
                position: relative;
                cursor: pointer;
                transition: 0.2s all ease;
                width: auto;
                &.selected,
                &:hover {
                    background: var(--theme-color-primary-light);
                    box-shadow: 0px 4px 16px -9px var(--theme-color-primary);
                }
            }
            .quick-start {
                color: white;
                display: flex;
                align-items: center;
                font-weight: bold;
                padding: 0.8rem 60px 0.8rem 0.2rem;
                margin: 0.7rem 0 0.7rem 45px;
                border: 1px solid transparent;
                border-radius: 8px;
                position: relative;
                cursor: pointer;
                -webkit-transition: 0.2s all ease;
                width: auto;
                background-position-x: 95%;
                background-position-y: center;
                background-repeat: no-repeat;
                &.selected,
                &:hover {
                    background-color: var(--theme-color-primary-light);
                    box-shadow: 0px 4px 16px -9px var(--theme-color-primary);
                    background-image: url(/internacional/public/office3/img/dashboard/training/ic-open-white.png);
                }
            }
            .hr {
                width: 85%;
                height: 1px;
                background: $secondary-color-8;
                margin: 1.5rem auto;
            }
            h2 {
                color: white;
                font-size: 1.1rem;
                font-weight: bold;
                margin: 0 0 0 45px;
            }
            .tutorials {
                margin-left: 1rem;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    left: 2.3rem;
                    top: 10%;
                    width: 1px;
                    height: 80%;
                    background: $secondary-color-8;
                }
            }
            .btn.not-finded {
                padding: 1rem 2rem;
                border: 1px solid white;
                color: white;
                text-align: center;
                border-radius: 7px;
                width: fit-content;
                margin: 2rem auto;
                transition: 0.2s all ease;
                &:hover {
                    background: var(--theme-color-primary-light);
                }
            }
        }
    }
    .box__middle {
        padding-left: 2rem;
        position: relative;
        box-shadow: 0px 4px 16px -9px var(--theme-color-primary);
        &::before {
            content: close-quote;
            position: absolute;
            width: 0;
            height: 0;
            top: 204px;
            box-sizing: border-box;
            border: 20px solid black;
            border-color: transparent transparent var(--theme-color-primary) var(--theme-color-primary);
            transform-origin: 0 0;
            transform: rotate(225deg);
            box-shadow: -2px 2px 2px 0px rgba(38, 36, 36, 0.15);
            left: 0px;
        }
        header {
            h1 {
                color: var(--theme-color-primary);
                font-weight: bold;
                font-size: 1.5rem;
                margin-top: 2rem;
            }
            h4 {
                color: #707070;
                font-weight: bold;
                font-size: 1.1rem;
                margin-bottom: 3rem;
            }
        }
        article.body {
            height: calc(100vh - 213px);
            overflow-y: auto;
            overflow-x: hidden;
            .normal__sentence {
                display: block;
                padding: 0.8rem 60px 0.8rem 0.2rem;
                // margin: 0.7rem 0 0.7rem 45px;
                margin: 0.7rem 0.7rem 0.7rem 45px;
                // width: max-content;
                width: auto;
                border: 1px solid transparent;
                border-radius: 8px;
                position: relative;
                color: #707070;
                cursor: pointer;
                &:hover, &.selected {
                    color: var(--theme-color-primary);
                    /*
                    background-image: url(/internacional/public/office3/img/dashboard/training/ic-open.png);
                    background-position-x: 95%;
                    background-position-y: center;
                    background-repeat: no-repeat;
                    */
                }
                &:after {
                    content: "";
                    border-radius: 50%;
                    position: absolute;
                    top: 0;
                    bottom: 0;
                    margin: auto 0;
                    left: -40px;
                    width: 32px;
                    height: 32px;
                    background: var(--theme-color-primary-light);
                    border: 1px solid var(--theme-color-primary);
                    transition: 0.4s all ease;
                    background-image: url("data:image/svg+xml,%3C%3Fxml version='1.0' %3F%3E%3Csvg height='15px' version='1.1' viewBox='0 0 18 15' width='18px' xmlns='http://www.w3.org/2000/svg' xmlns:sketch='http://www.bohemiancoding.com/sketch/ns' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle/%3E%3Cdesc/%3E%3Cdefs/%3E%3Cg fill='none' fill-rule='evenodd' id='Page-1' stroke='none' stroke-width='1'%3E%3Cg fill='%23FFFFFF' id='Core' transform='translate(-423.000000, -47.000000)'%3E%3Cg id='check' transform='translate(423.000000, 47.500000)'%3E%3Cpath d='M6,10.2 L1.8,6 L0.4,7.4 L6,13 L18,1 L16.6,-0.4 L6,10.2 Z' id='Shape'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
                    background-size: 60%;
                    background-position: center;
                    background-repeat: no-repeat;
                    
                }
                &.no-link {
                    &:hover {
                        color: var(--theme-color-primary);
                        background-image: none;
                    }
                }
            }
            .childrens {
                a {
                    padding: 0.8rem 60px 0.8rem 0.2rem;
                    // margin: 0.7rem 0 0.7rem 45px;
                    margin: 0.7rem 0.7rem 0.7rem 45px;
                    // width: max-content;
                    width: auto;
                    border: 1px solid transparent;
                    border-radius: 8px;
                    position: relative;
                    color: #707070;
                    cursor: pointer;
                    &:hover, &.selected {
                        color: var(--theme-color-primary);
                        /*
                        background-image: url(/internacional/public/office3/img/dashboard/training/ic-open.png);
                        background-position-x: 95%;
                        background-position-y: center;
                        background-repeat: no-repeat;
                        */
                    }
                    &:after {
                        content: "";
                        border-radius: 50%;
                        position: absolute;
                        top: 0;
                        bottom: 0;
                        margin: auto 0;
                        left: -23px;
                        width: 18px;
                        height: 18px;
                        background: var(--theme-color-primary-light);
                        border: 1px solid var(--theme-color-primary);
                        transition: 0.4s all ease;
                        opacity: .7;
                    }
                }
            }
        }
    }
    .box__right {
        max-height: calc(100vh - 84px);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-around;
        padding: 10px;
        // border-left: 1px solid #cecece;
        > div {
            height: auto;
            width: 100%;
            .container__youtube {
                box-shadow: 0 8px 17px 2px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);
            }
        }
        img {
            width: 50%;
            max-width: 300px;
        }
    }
}
.button3 {
    padding: 2rem 5rem;
    transition: 0.3s all ease;
    font-weight: bold;
    font-size: 1.1rem;
    margin: 1rem 0;
    &:hover {
        box-shadow: $primary-color 0px 0px 12px 0px;
    }
}
@media (max-width: 900px) {
    .container__grid {
        grid-template-columns: unset;
    }
}
@keyframes loading {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/dashboard/training/index.vue